/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Notify_Title6Inputs */

const en_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push & engagement`)
};

const ar_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدفع والتفاعل`)
};

const bn_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পুশ ও এনগেজমেন্ট`)
};

const de_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push & Engagement`)
};

const es_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje y compromiso`)
};

const fr_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée et engagement`)
};

const pt_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulso e engajamento`)
};

const zh_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推动和参与`)
};

const tr_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İtme ve katılım`)
};

const ru_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push и взаимодействие`)
};

const pl_svc_mobile_app_development_notify_title6 = /** @type {(inputs: Svc_Mobile_App_Development_Notify_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacisk i zaangażowanie`)
};

/**
* | output |
* | --- |
* | "Push & engagement" |
*
* @param {Svc_Mobile_App_Development_Notify_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_notify_title6 = /** @type {((inputs?: Svc_Mobile_App_Development_Notify_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Notify_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_notify_title6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_notify_title6(inputs)
	return en_svc_mobile_app_development_notify_title6(inputs)
});
export { svc_mobile_app_development_notify_title6 as "svc_mobile-app-development_NOTIFY_title" }